import { cn } from "../../../shared/ui";

/** A headline number with a label and a note, matching the other report screens. */
export function Figure({
  label,
  value,
  note,
  tone,
}: {
  label: string;
  value: string;
  note?: string;
  tone?: "amber" | "red" | "green";
}) {
  return (
    <div className="rounded-xl border border-ink-200 bg-surface px-4 py-3">
      <p className="text-xs text-ink-500">{label}</p>
      <p
        className={cn(
          "tnum mt-1 font-display text-2xl font-semibold",
          tone === "red"
            ? "text-red-700"
            : tone === "amber"
              ? "text-amber-700"
              : tone === "green"
                ? "text-emerald-700"
                : "text-ink-900",
        )}
      >
        {value}
      </p>
      {note && <p className="mt-0.5 text-xs text-ink-500">{note}</p>}
    </div>
  );
}

/** A signed percentage the way a report reads it: "+80%", "−12%", or "—" when unmeasured. */
export function percent(value: number | null | undefined): string {
  if (value == null) {
    return "—";
  }
  const rounded = Math.round(value);
  return `${rounded > 0 ? "+" : ""}${rounded}%`;
}

/** A plain percentage (no sign), for on-time rates. */
export function rate(value: number | null | undefined): string {
  return value == null ? "—" : `${Math.round(value)}%`;
}

/** A day count as words: "3 days", "1 day", "—". */
export function days(value: number | null | undefined): string {
  if (value == null) {
    return "—";
  }
  const rounded = Math.round(value * 10) / 10;
  return `${rounded} ${rounded === 1 ? "day" : "days"}`;
}
